import React, { useEffect } from 'react';
import { duplicateItems } from '../state/actions/duplicate-items';
import { isEventTargetInputElement } from '../utils/is-event-target-input-element';
import {
  useSelectedItems,
  useTracks,
  useWriteContext,
} from '../utils/use-context';

export const DuplicateLayers: React.FC = () => {
  const { selectedItems } = useSelectedItems();
  const { setState } = useWriteContext();
  const { tracks } = useTracks();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // target이 input이면 trigger하지 않음
      if (isEventTargetInputElement(e)) {
        return;
      }

      const commandKey = window.navigator.platform.startsWith('Mac')
        ? e.metaKey
        : e.ctrlKey;

      if (e.key === 'd' && commandKey && selectedItems.length > 0) {
        // lock된 아이템 필터링
        const duplicatableItems = selectedItems.filter((itemId) => {
          const track = tracks.find((t) => t.items.includes(itemId));
          return !track?.locked;
        });

        if (duplicatableItems.length === 0) {
          return;
        }

        e.preventDefault();
        setState({
          update: (state) => duplicateItems(state, duplicatableItems),
          commitToUndoStack: true,
        });
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedItems, setState, tracks]);

  return null;
};
